import React from "react";
import { Col, Row, Button } from "reactstrap";
import CompetitiveInsightsChart from "../DashboardCharts/CompetitiveInsightsChart";
import DashboardDistributorBreakdownChart from "../DashboardCharts/DashboardDistributorBreakdownChart";
import DashboardTotalOpportunititesChart from "../DashboardCharts/DashboardTotalOpportunitiesChart";
import useDashboard from "../useDashboard";
import { Theme } from "../../../config/constants";

const DashboardChartsCard = () => {
    const { handleClickViewCampaignManagement } = useDashboard.useDashboard();

    return (
        <Col style={{background: 'lightgray', gap: '1px', display: 'grid'}}>
            <Row className="m-0" style={{gap: '1px'}}>
                <Col className="col-xxl-6 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{background: 'white'}}>
                    <DashboardDistributorBreakdownChart />
                </Col>
                <Col style={{background: 'white'}}>
                    <CompetitiveInsightsChart />
                </Col>
            </Row>
            <Row className="m-0" style={{gap: '1px'}}>
                <Col className="col-xxl-6 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{background: 'white'}}>
                    <DashboardTotalOpportunititesChart />
                </Col>
                <Col className="w-100 d-flex flex-column justify-content-center" style={{minHeight: '315px', background: 'white'}}>
                    <Row className="mx-auto w-fc">
                        <img src={'./vectorcharts.png'} alt='Fake Charts and Graphs' style={{height: '59px', width: '211px'}}/>
                    </Row>
                    <Row className="mx-auto w-fc">
                        <div className="main-header text-size-18">Want more Campaign Insights?</div>
                    </Row>
                    <Row className="mx-auto w-fc">
                        <div className="text-grayText text-center">Access our Campaign Management page for full insights on your campaigns.</div>
                    </Row>
                    <Row className="mx-auto my-1 w-fc">
                        <Button 
                            block 
                            className='py-2 button-label' 
                            size='sm' 
                            style={{width: '250px'}}
                            onClick={() => handleClickViewCampaignManagement()}
                            color={Theme().colors.accentName}>View Campaign Management
                        </Button>
                    </Row>
                </Col>
            </Row>
        </Col>
    )   
}

export default DashboardChartsCard;